/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HchbBranchSummary } from './HchbBranchSummary';
import {
    HchbBranchSummaryFromJSON,
    HchbBranchSummaryFromJSONTyped,
    HchbBranchSummaryToJSON,
    HchbBranchSummaryToJSONTyped,
} from './HchbBranchSummary';

/**
 * 
 * @export
 * @interface HchbBranchList
 */
export interface HchbBranchList {
    /**
     * 
     * @type {Array<HchbBranchSummary>}
     * @memberof HchbBranchList
     */
    data: Array<HchbBranchSummary>;
}

/**
 * Check if a given object implements the HchbBranchList interface.
 */
export function instanceOfHchbBranchList(value: object): value is HchbBranchList {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function HchbBranchListFromJSON(json: any): HchbBranchList {
    return HchbBranchListFromJSONTyped(json, false);
}

export function HchbBranchListFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbBranchList {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(HchbBranchSummaryFromJSON)),
    };
}

export function HchbBranchListToJSON(json: any): HchbBranchList {
    return HchbBranchListToJSONTyped(json, false);
}

export function HchbBranchListToJSONTyped(value?: HchbBranchList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(HchbBranchSummaryToJSON)),
    };
}

